var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.slides
    ? _c(
        "div",
        { staticClass: "thumbnail-gallery carousel" },
        [
          _c(
            "agile",
            {
              ref: "agile__thumbnails",
              staticClass: "agile__thumbnails",
              attrs: { options: _vm.options, "as-nav-for": _vm.asNavFor }
            },
            [
              _vm._l(_vm.slides, function(slide, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "slide slide--thumbnail",
                    class: "slide--" + index,
                    on: {
                      click: function($event) {
                        return _vm.$refs.agile__thumbnails.goTo(index)
                      }
                    }
                  },
                  [
                    _c("a", { attrs: { href: slide } }, [
                      _c("img", { attrs: { src: slide } })
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _c("template", { slot: "prevButton" }, [
                _c("img", {
                  attrs: { src: "/img/icons/arrow-left.svg", alt: "" }
                })
              ]),
              _vm._v(" "),
              _c("template", { slot: "nextButton" }, [
                _c("img", {
                  attrs: { src: "/img/icons/arrow-right.svg", alt: "" }
                })
              ])
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39080cd5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39080cd5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/shared/ThumbnailGallery.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-39080cd5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/shared/ThumbnailGallery.vue
// module chunks = 0 1